export const verificationIdParam = 'verificationId';
export const frontendTypeParam = 'frontendType';
export const failedAttemptParam = 'failedAttempt';

export const MainPageRoute = `/`;
export const AspspSelectPageRoute = '/banks';
export const VerificationPageRoute = '/redirect';
export const ContactPageRoute = '/contact';
export const DefinitionPageRoute = '/definitions';
export const LoaderPageRoute = '/loader';
export const SmartFlowPageRoute = '/smartFlow';
